export default __webpack_public_path__ + "static/media/logoanimate.a394bffd.svg";